import styled from 'styled-components';

const CommonContainer = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  padding-top: 56px;
  padding-bottom: 48px;
  border-top: 1px solid #d7dfe7;

  & > * {
    flex-basis: ${props => (props.theme.isMobile ? 100 : 50)}%;
  }

  ${props => props.theme.isMobile && `
    & > *:not(:last-child) {
      margin-bottom: 40px;
    }
  `};
`;

const VFlex = styled.div`
  display: flex;
  flex-direction: column;

  & > em {
    font-style: normal;
    font-size: 20px;
    font-weight: ${props => props.theme.fontWeightHeavy};
    line-height: 110%;
    text-transform: uppercase;
  }

  & > strong {
    font-size: 28px;
    font-weight: ${props => props.theme.fontWeightHeavy};
    line-height: 120%;
    margin-bottom: 8px;
  }

  & > small {
    font-size: 19px;
    line-height: 130%;
  }

  > p.fund-title {
    font-size: 28px;
    font-weight: ${props => props.theme.fontWeightHeavy};
    line-height: 120%;
    margin: 8px 0;

    > strong {
      padding-right: 12px;
    }
  }
`;

const TriStateButton = styled.button`
  outline: none;
  text-transform: uppercase;
  color: ${props => (props.pale ? props.theme.bodyColor : 'white')};
  font-size: 16px;
  font-weight: ${props => props.theme.fontWeightHeavy};
  line-height: 120%;
  border-radius: 5px;
  height: 56px;
  width: 100%;
  max-width: 285px;

  ${props => props.theme.isMobileOrTablet && `
    max-width: unset;
  `};

  background-color: ${props => (props.pale ? 'white' : '#303d56')};
  border: 1px solid ${props => (props.pale ? props.theme.secondaryColor : '#303d56')};
  box-shadow: 0px 2px 8.67924px rgba(0, 0, 0, 0.08);
  &:hover {
    background-color: ${props => (props.pale ? 'white' : '#232e41')};
    border: 1px solid ${props => (props.pale ? props.theme.bodyColor : '#232e41')};
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.12);
  }
  &:active {
    background-color: ${props => (props.pale ? 'white' : '#303d56')};
    border: 1px solid ${props => (props.pale ? props.theme.bodyColor : '#303d56')};
    box-shadow: none;
  }
`;

export {
  TriStateButton,
  CommonContainer,
  VFlex,
};
